// noinspection JSUnresolvedReference

(function(app) {
    const elements = {};

    app.FlagPositionToggle = {
        init() {
            elements.flagPositionRadioEls = document.querySelectorAll('.wdpp-radio--flag-position');
            elements.flagPositionDisplayEl = document.querySelector('.wdpp-display--flag-position');
            console.log(elements.flagPositionRadioEls);

            // Validate required elements
            if (!app.Utils.validateElements('flag position inputs', {
                'flag position radio buttons': elements.flagPositionRadioEls,
                'flag position display element': '.wdpp-display--flag-position'
            })) {
                return;
            }

            elements.flagPositionRadioEls.forEach(radio => {
                radio.addEventListener('change', () => {
                    if (radio.checked) {
                        app.Store.setState('flagPosition', radio.value);
                        console.log(`Flag position changed to: ${radio.value}`);
                    }
                });
            });

            // Initialize display
            const currentValue = app.Store.getState('flagPosition');
            if (currentValue) {
                this.updateFlagPositionDisplay(currentValue);
            }

            // Subscribe to store changes
            app.Store.subscribe('flagPosition', (value) => this.updateFlagPositionDisplay(value));

            // Set initial value in store
            const checkedRadio = Array.from(elements.flagPositionRadioEls).find(r => r.checked);
            if (checkedRadio) {
                app.Store.subscribe('initialized', () => {
                    app.Store.setState('flagPosition', checkedRadio.value);
                });
            }
        },

        updateFlagPositionDisplay(value) {
            if (elements.flagPositionDisplayEl && elements.flagPositionRadioEls.length) {
                const checkedRadio = Array.from(elements.flagPositionRadioEls).find(r => r.value === value);
                if (checkedRadio) {
                    elements.flagPositionDisplayEl.textContent = checkedRadio.getAttribute('data-flag-position-friendly-name');
                }
            }
        },
        
        /**
         * Get the flag position data for cart export
         * @returns {object} The flag position data for the cart
         */
        getCartData() {
            return {
                flagPosition: app.Store.getState('flagPosition') || 'right',
            };
        },

        /**
         * Get the flag position data for price calculation
         * @returns {object} The flag position data for the price
         */
        getPriceData() {
            return {
                flagPosition: app.Store.getState('flagPosition') || 'right',
            };
        }
    };
})(window.app = window.app || {}); 